exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NoAuthModal-module__content___3MsHd{display:grid;gap:1rem;justify-content:center;align-items:center;text-align:center}.NoAuthModal-module__content___3MsHd img{margin:0 auto}.NoAuthModal-module__content___3MsHd .NoAuthModal-module__button-wrapper___2zFkg{display:grid;gap:1rem;grid-auto-flow:column;justify-content:center}", ""]);

// exports
exports.locals = {
	"content": "NoAuthModal-module__content___3MsHd",
	"button-wrapper": "NoAuthModal-module__button-wrapper___2zFkg"
};